var path = 'scripts/views/components/po-data-button.html';
var html = "<button class=\"find-po-data-btn btn mls action-button hidden-xs hidden-sm\"\n        ng-if=\"$ctrl.showButton()\"\n        ng-click=\"$ctrl.buttonAction()\"\n        ng-class=\"$ctrl.anyTransactionLinked() ? 'btn-default' : 'btn-primary'\"\n        ng-disabled=\"!$ctrl.anyTransactions()\"\n        analytics-on=\"click\"\n        analytics-properties=\"{eventAsset:'Find PO Data', 'tab':'transactionTab'}\">\n        <span class=\"fa fa-link\"></span>\n        <span>{{ $ctrl.buttonText() | translate }}</span>\n</button>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/views/components/po-data-button.html
// module id = 329
// module chunks = 0